<div class="itsl-course-catalogue-register">
    <Page contentAreaLayout="narrow">
        <PageHeader title="{i18n.registerFor}" backButtonText="{i18n.backTo}" on:pageHeaderBack={() => dispatch('finished')} />
        {#if showCreateAccountUsingAnotherSite}
            <AccountOnAnotherSite
                title={i18n.iHaveItslearningAccountButNotFrom}
                description={i18n.thisCourseBelongsTo}
                searchForSchoolOrSite={i18n.searchForSchoolOrSite}
                buttonText={i18n.register}
                redirectUrl={verifyAnotherCustomerUrl}
                errorMessage = {i18n.schoolOrSiteUselectedErrorMessage}
                {currentCustomerId}
                kpiAction={() => measureKpi(MEASUREMENTS.CreateAccountWithItslearningLogin, antiForgery)}
            />
        {/if}
        <div class="content-block">
            <Form>
                <FormSection title="{i18n.iHaveItslearningAccountFrom}" description="{i18n.ifYouPreviouslyRegistered}">
                    <Button type="secondary" large text="{i18n.logIn}" on:click={loginToThisSite} />
                </FormSection>
            </Form>
        </div>
        {#if showCreateAccountUsingEmail }
            <div class="content-block">
                <Form>
                    <FormSection title={showCreateAccountUsingAnotherSite ? i18n.iDontHaveItslearningAccount : i18n.iDontHaveItslearningAccountOnSite}>
                        <Button type="secondary" large text="{i18n.createANewAccount}" on:click={createUsingEmail} />
                    </FormSection>
                </Form>
            </div>
        {/if}
    </Page>
</div>

<script>
    import { createEventDispatcher } from 'svelte';
    import { measureKpi } from '../../api.js';
    import { MEASUREMENTS } from '../../constants.js';

    import AccountOnAnotherSite from "@its-ui/common-components/AccountOnAnotherSite/AccountOnAnotherSite.svelte";
    import Form from '@itslearning/prometheus/assets/inputs/Form/v1/Form.svelte';
    import Page from "@itslearning/prometheus/assets/templates/Page/v1/Page.svelte";
    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import FormSection from "@itslearning/prometheus/assets/inputs/Form/v1/FormSection.svelte";
    import PageHeader from '@itslearning/prometheus/assets/patterns/PageHeader/v1/PageHeader.svelte';

    /**
     * @typedef {Object} RegisterTerms
     * @property {string} backTo
     * @property {string} registerFor
     * @property {string} iHaveItslearningAccountButNotFrom
     * @property {string} thisCourseBelongsTo
     * @property {string} searchForSchoolOrSite
     * @property {string} iHaveItslearningAccountFrom
     * @property {string} logIn
     * @property {string} iDontHaveItslearningAccount
     * @property {string} thisCourseBelongsToAnotherOrg
     * @property {string} register
     * @property {string} createANewAccount
     * @property {string} schoolOrSiteUselectedErrorMessage
     */

    /** @type RegisterTerms */
    export let i18n;

    /** @type {import('../../api.js').AntiForgery} */
    export let antiForgery;

    /** @type boolean */
    export let showCreateAccountUsingAnotherSite;

    /** @type boolean */
    export let showCreateAccountUsingEmail;

    /** @type number */
    export let courseId;

    /** @type string */
    export let newAccountWithEmailEnrollmentUrl = '';

    /** @type number */
    export let currentCustomerId;

    const dispatch = createEventDispatcher();

    const verifyAnotherCustomerUrl = (customerId) => `/Courses/catalogue/external/verifyidentity?customerId=${customerId}&courseId=${courseId}`;

    const verifySameSiteUrl = (courseId) => `/Courses/catalogue/external/${courseId}/confirmsamesitelogin`;

    async function loginToThisSite() {
        await measureKpi(MEASUREMENTS.LoginAsRecurringUser, antiForgery);
        window.location.href = verifySameSiteUrl(courseId);
    }

    async function createUsingEmail() {
        await measureKpi(MEASUREMENTS.CreateAccountWithEmail, antiForgery);
        window.location.href = newAccountWithEmailEnrollmentUrl;
    }
</script>
